import { request } from '../../../shared/api/httpClient';
export interface CatalogItem {
  id: string; title: string; price?: number; total_price?: number; duration_minutes?: number; category_id?: string;
  description_text?: string; note?: string; items?: { service_title: string; service_price: number }[];
  store_id?: string; sku?: string; image_url?: string; booking_count?: number; revenue?: number;
  booking_enabled?: boolean; active?: boolean; staff_ids?: string[];
}
export type CatalogKind = 'services' | 'categories' | 'combos';
export async function listCatalog(kind: CatalogKind, signal?: AbortSignal) {
  const path = kind === 'services' ? '/services' : kind === 'categories' ? '/services/categories' : '/service-combos';
  const response = await request<Record<string, CatalogItem[]>>(path, { signal });
  return response[kind];
}
